import { DOMAIN_COOKIE } from '../../../constants';
import { REQUEST_LOGOUT, SUCCESS_LOGOUT } from './constants';
import { COOKIE_KEY_ACCESS, COOKIE_KEY_ID, COOKIE_KEY_USERNAME } from '../../../constants/cookie';

import { resetInfos } from '../../account/actions';
import { forceFetchPartners } from '../../partner/actions';

import { makeActionCreator } from '../../../utils/actionsUtils';

// indique qu'une demande de logout a été faite au serveur
export const requestLogout = makeActionCreator(REQUEST_LOGOUT);
// indique que la demande de logout a été acceptée
export const successLogout = makeActionCreator(SUCCESS_LOGOUT);

export function logoutUser(callback) {
    return dispatch => {
        dispatch(requestLogout());
        dispatch(successLogout());
        deleteCookies();
        dispatch(resetInfos());
        dispatch(forceFetchPartners());
        if (callback) {
            callback();
        }
    };
}

const deleteCookie = name => {
    document.cookie =
        name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' + DOMAIN_COOKIE;
};

function deleteCookies() {
    deleteCookie(COOKIE_KEY_USERNAME);
    deleteCookie(COOKIE_KEY_ACCESS);
    deleteCookie(COOKIE_KEY_ID);
}



// WEBPACK FOOTER //
// ./src/services/authentication/logout/actions.js